// NOTE THAT THIS IS NOT NECESSARILY IN SYNCH WITH WHAT'S IN GATSBY-NODE.JS!

const trimDashes = (x) => x.replace(/^-+|-+$/gm, "");

const makeSlug = (name) =>
  encodeURIComponent(
    trimDashes(
      String(name)
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[?.,/#!$%^&‘*;"“”:{}=\-–_'’`~()]/g, "")
        .replace(/\s+/g, "-")
        .substring(0, 199)
    )
  );

export default makeSlug;
